export default __webpack_public_path__ + "static/img-slider-07-4fcbc64421718ff6b2a37f145a8aa2ca.png";